import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_checkbox = _resolveComponent("app-checkbox")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["app-dropdown-item", { selected: _ctx.isSelected }]),
    onClickCapture: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggle()), ["prevent","stop"])),
    style: _normalizeStyle({ 'font-size': _ctx.fontSize })
  }, [
    (_ctx.showCheckbox)
      ? (_openBlock(), _createBlock(_component_app_checkbox, {
          key: 0,
          checked: _ctx.isSelected
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              innerHTML: _ctx.details.label
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["checked"]))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          innerHTML: _ctx.details.label
        }, null, 8, _hoisted_2))
  ], 38))
}